// src/utils/projectBuilder.js

export function buildProject({ ownerUser, mode, rooms, summary }) {
  const projectId =
    (crypto?.randomUUID && crypto.randomUUID()) || `proj_${Date.now()}`;

  const ownerUid = ownerUser?.uid || null;
  const ownerEmail = ownerUser?.email || null;

  return {
    id: projectId,
    createdAt: new Date().toISOString(),

    // who / where it came from
    ownerUid,
    ownerEmail,
    mode: mode || "unknown",

    // payload
    rooms: rooms || [],
    summary: summary || null,
  };
}
